import { render, staticRenderFns } from "./Calendar.vue?vue&type=template&id=4d5bad6f"
import script from "./Calendar.vue?vue&type=script&lang=ts"
export * from "./Calendar.vue?vue&type=script&lang=ts"
import style0 from "./Calendar.vue?vue&type=style&index=0&id=4d5bad6f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports